var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"related-forum-item"},[_c('router-link',{staticClass:"forum-link typo-body-2",attrs:{"to":{ name: 'ForumSection', params: { slug: _vm.forum.slug || _vm.forum.id } }}},[_vm._v(" "+_vm._s(_vm.forum.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }